
<template>
  <div class="user-info">
    <img v-if="userInfo" :src="userInfo.Avatar" class="avatar" />
    <img v-else src="@/assets/icon/avatar.jpg" class="avatar" />
    <div class="name">
      {{ userInfo?.Name || 'Joan Doe' }}
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  }
}
</script>
<style lang="scss" scoped>
.user-info {
  padding-top: 0.5rem;
  display: flex;
  align-items: center;

  .avatar {
    width: 2.25rem;
    height: 2.25rem;
  }

  .name {
    font-size: 0.88rem;
    color: #000000;
    margin-left: 0.6rem;
    font-weight: bold;
  }
}
</style>
